import { TextField, Typography } from '@mui/material'
import { useState, useEffect } from 'react'
import { Dialog } from './Dialog'
import { Target } from '../utils/dataFormatting'
import { habitTypeNameMap, mainPriorityMainValue, regularTargetValue } from '../utils/constants'
import _ from 'lodash'

interface Props {
  isOpen: boolean
  targetBeingEdited: Target
  onSubmit: (newTarget: Target) => void
  onCancel: Function
}

const EditTargetDialog = ({
  isOpen,
  targetBeingEdited,
  onSubmit,
  onCancel,
}: Props) => {
  const [text, setText] = useState(targetBeingEdited.text)
  const [miwStarterTarget, setMiwStarterTarget] = useState<number | undefined>(targetBeingEdited.miwStarterTarget)
  const [miwMainTarget, setMiwMainTarget] = useState<number | undefined>(targetBeingEdited.miwMainTarget)

  const miwStarterTargetIsZero = miwStarterTarget === 0
  const miwStarterTargetIsGtMain = !_.isNil(miwStarterTarget) && !_.isNil(miwMainTarget) && miwStarterTarget >= miwMainTarget
  const miwMainTargetIsTooHigh = (miwMainTarget || 0) > 180

  const miwTargetsAreInvalid =
    miwStarterTargetIsZero
    || miwStarterTargetIsGtMain
    || miwMainTargetIsTooHigh

  return (
    <Dialog
      isOpen={isOpen}
      title={`🎯 Enter your new target!`}
      text={`Editing '${habitTypeNameMap[targetBeingEdited.habitType]}'`}
      submitText="Save!"
      onSubmit={() => onSubmit({...targetBeingEdited, text, miwStarterTarget: miwStarterTarget, miwMainTarget: miwMainTarget})}
      onClose={onCancel}
      isSubmitDisabled={miwTargetsAreInvalid}
    >
      <TextField
        placeholder="Enter your new target!"
        multiline={true}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      {targetBeingEdited.habitType === "miw" && (
        <>
          <Typography variant="body1" style={{ marginTop: '10px', marginBottom: '10px' }}>
            Set your Starter and Main targets for daily time spent below.
            You get {regularTargetValue} points for hitting your Starter target and 
            {mainPriorityMainValue} for hitting your Main one!
          </Typography>
          <TextField
            label="Starter time"
            type="number"
            value={miwStarterTarget}
            onChange={(e) => setMiwStarterTarget(Number(e.target.value))}
            style={{marginBottom: 15}}
          />
          <TextField
            label="Main time"
            type="number"
            value={miwMainTarget}
            onChange={(e) => setMiwMainTarget(Number(e.target.value))}
          />
          {
            miwTargetsAreInvalid &&
              <p>
                {
                  miwStarterTargetIsZero ?
                    "Your Starter target must be greater than zero."
                  : miwStarterTargetIsGtMain ?
                    "Your Starter target can't be greater than your Main target."
                  : miwMainTargetIsTooHigh ?
                    "Your Main target can't be greater than 3 hours. Make this your MOST important work!"
                  :
                    ""
                }
              </p>
          }
        </>
      )}
    </Dialog>
  )
}

export default EditTargetDialog
